/* global __WATCH__:false, __SERVICE_WORKER__:false, __GA__:false */
/**
 * Moment.js
 *
 * ALERT : Use this to Turn off the depreciation warnings we are getting in moment - the issue really needs fixing though
 *
 * http://momentjs.com/guides/#/warnings/js-date/
 * https://stackoverflow.com/questions/23263380/deprecation-warning-moment-construction-falls-back-to-js-date
 *
 * Moment construction falls back to js Date.
 * This is discouraged and will be removed in an upcoming major release.
 * This deprecation warning is thrown when no known format is found for a date passed into the string constructor. To work around this issue, specify a format for the string being passed to moment().
 */
// moment.suppressDeprecationWarnings = true;
/**
 * Moment.js
 */

import '../stylus/mainvertical.styl';

import PerfectScrollbar from 'perfect-scrollbar'; // css added to stylus/perfect_scrollbar.styl

import { DOMReady } from 'utils/dom';
import { ensightenTrackingSetup } from 'modules/ensighten_tracking/EnsightenTracking';

const createCarouselWidget = require('modules/CarouselWidget');
const createFeatureDetailController = require('modules/FeatureDetailController');
const createGenericPopupContorller = require('modules/GenericPopupController');
const createNewsFeedController = require('modules/NewsFeedController');
const createSearchAutoCompleteController = require('modules/SearchAutoCompleteController');
const createVideoInlineController = require('modules/VideoInlineController');
const createVideoPopupController = require('modules/VideoPopupController');
const createVideoPageController = require('modules/VideoPageController');
const createTVGuideController = require('modules/TVGuideController');
const createFeaturesLandingController = require('modules/FeaturesLandingController');
const createShareController = require('modules/ShareController');
const createHandleBarsTemplates = require('modules/HandlebarsTemplates');
const Cookies = require('js-cookie');
const Spdy = require('modules/Speedy');

const TURNERENTS = window.TURNERENTS || {};

/**
 * When dom is ready initialise
 */
DOMReady(() => {
  console.log('++++ DOM Ready');
});

/**
 * When all content is loaded start
 */
window.addEventListener('load', () => {
  console.log('++++ DOM load');
  addOneTrustListeners();
  if (!TURNERENTS.oneTrustActive && TURNERENTS.analyticsEnabled) {
    // initialise tracking if oneTrust is disabled via CMS
    ensightenTrackingSetup();
  }
});

document.addEventListener('onetrust_init', () => {
  //store.onTrustActive = true;
  console.log('++++ ONETRUST_INIT');
  addOneTrustListeners();
  if (TURNERENTS.analyticsEnabled) {
    ensightenTrackingSetup();
  }
});

/**
 * ONETREUST : Seems like the dom has changed!!
 * https://my.onetrust.com/s/article/UUID-534defd9-7ec8-fc0e-78bf-8dce8c6c5593?topicId=0TO1Q000000ItTAWA0
 * var acceptButton = document.getElementsByClassName("optanon-allow-all")[0];
 * var saveSettingButton = document.getElementsByClassName("optanon-white-button-middle")[0];
 * var allowAllButton = document.getElementsByClassName("optanon-white-button-middle")[1];
 * acceptButton.addEventListener('click', function(){
 * 	location.reload();
 * });
 * allowAllButton.addEventListener('click', function(){
 * 	location.reload();
 * });
 * saveSettingButton.addEventListener('click', function(){
 * 	location.reload();
 * });
 * */
const addOneTrustListeners = () => {
  const acceptButton = document.getElementById('onetrust-accept-btn-handler');
  const allowAllButton = document.getElementById('accept-recommended-btn-handler');
  const saveSettingButton = document.getElementsByClassName('onetrust-close-btn-handler')[0];
  if (acceptButton) {
    acceptButton.addEventListener('click', () => {
      location.reload();
    });
  }
  if (allowAllButton) {
    allowAllButton.addEventListener('click', () => {
      location.reload();
    });
  }
  if (saveSettingButton) {
    saveSettingButton.addEventListener('click', () => {
      location.reload();
    });
  }

  // document.body.addEventListener('click', (e) => {
  //   if (e.target && e.target.classList.contains('optanon-allow-all')) {
  //     window.location.reload();
  //   }
  //   if (
  //     e.target &&
  //     e.target.parentNode &&
  //     e.target.parentNode.classList.contains('optanon-white-button-middle')
  //   ) {
  //     window.location.reload();
  //   }
  // });
};

Spdy.ready(() => {
  const HandlebarsTemplates = createHandleBarsTemplates({});
  window.HandlebarsTemplates = HandlebarsTemplates;

  TURNERENTS.createVideoButtonClick = function() {
    Spdy('[data-videoid]').on('click', function(e) {
      Spdy.preventDefault(e);
      TURNERENTS.popupVideoController.openVideo({
        type: Spdy(this).data('videotype'),
        id: Spdy(this).data('videoid'),
        tracking_name: Spdy(this).data('videoname'),
      });
    });
  };
  TURNERENTS.destroyVideoButtonClick = function() {
    Spdy('[data-videoid]').off('click');
  };

  TURNERENTS.createInlineVideoButtonClick = function() {
    Spdy('[data-inlinevideoid]').on('click', function(e) {
      Spdy.preventDefault(e);
      Spdy('[data-inlinevideoid]').removeClass('active');
      Spdy(this).addClass('active');
      TURNERENTS.inlineVideoController.openVideo({
        type: Spdy(this).data('videotype'),
        id: Spdy(this).data('inlinevideoid'),
        tracking_name: Spdy(this).data('videoname'),
      });
    });
  };
  TURNERENTS.destroyInlineVideoButtonClick = function() {
    Spdy('[data-inlinevideoid]').off('click');
  };

  Spdy('.overlay .arrow').on('click', function() {
    Spdy(Spdy(this).parent()).toggleClass('active');
  });

  TURNERENTS.generic_popup = createGenericPopupContorller({
    copy: TURNERENTS.footer_copy,
  });

  // CHECK TO SEE IF WE NEED TO AUTO-OPEN A POPUP BASED ON HASH QUERY
  let hash = window.location.hash.substring(1);
  Spdy('.links [data-trigger]').each(function(index, item) {
    if (Spdy(item).data('trigger') == hash) {
      TURNERENTS.generic_popup.onPopupOpen(item);
    }
  });
  // CHECK TO SEE IF WE NEED TO AUTO-OPEN A VIDEO POPUP BASED ON HASH QUERY
  if (Spdy('.popup.video').elements.length > 0) {
    TURNERENTS.popupVideoController = createVideoPopupController({});
  }

  TURNERENTS.inlineVideoController = createVideoInlineController({});

  //setup inital video buttons (video thumbnails)
  TURNERENTS.destroyVideoButtonClick();
  TURNERENTS.createVideoButtonClick();

  TURNERENTS.destroyInlineVideoButtonClick();
  TURNERENTS.createInlineVideoButtonClick();

  resizeCallback();
  Spdy(window).on('resize', function() {
    resizeCallback();
  });
  Spdy(window).on('orientationChange', function() {
    resizeCallback();
  });

  document.addEventListener('youtubeAPIready', () => {
    TURNERENTS.inlineVideoController.youTubeApiReady();
    TURNERENTS.popupVideoController && TURNERENTS.popupVideoController.youTubeApiReady();
  });

  //If TV Guide data variable exists (was populated by php page) , then attempt to load guide
  if (TURNERENTS.TVGUIDE_DATA) {
    TURNERENTS.tv_guide = createTVGuideController({
      locale: TURNERENTS.language_code,
      guide_template: HandlebarsTemplates.TVGuide,
      date_picker_template: HandlebarsTemplates.DatePicker,
      upcoming_carousel_template: HandlebarsTemplates.TVGuideUpcomingCarousel,
      guide_container: Spdy('.tv_guide_container'),
      date_picker_container: Spdy('.date_picker_container'),
      tv_data_url: TURNERENTS.TVGUIDE_DATA.tv_data_url,
      tvguide_lookup: TURNERENTS.TVGUIDE_DATA.tvguide_lookup,
      primetime: TURNERENTS.TVGUIDE_DATA.primetime,
      cms_calendar: TURNERENTS.TVGUIDE_DATA.calendar,
      date_format: TURNERENTS.TVGUIDE_DATA.date_format,
      height_per_hour: 150, //1.5rem height multiplier,
      section_data: TURNERENTS.TVGUIDE_DATA.section_data,
      backup_image: TURNERENTS.TVGUIDE_DATA.backup_image || null,
    });
  }

  //If FEATURE_LANDING_DATA data variable exists (was populated by php page) , then attempt to load guide
  if (TURNERENTS.FEATURE_LANDING_DATA) {
    TURNERENTS.feature_landing = createFeaturesLandingController({
      static_url: TURNERENTS.static_url,
      dynamic_url: TURNERENTS.dynamic_url,
      locale: TURNERENTS.language_code,
      friendly_url: TURNERENTS.FEATURE_LANDING_DATA.friendly_url,
      data: TURNERENTS.FEATURE_LANDING_DATA.data,
      filters: TURNERENTS.FEATURE_LANDING_DATA.filters,
      feature_template: HandlebarsTemplates.FeatureLanding,
      filtersGenreKeys: TURNERENTS.FEATURE_LANDING_DATA.filtersGenreKeys,
    });
  }
  if (TURNERENTS.FEATURE_DETAILS_DATA) {
    TURNERENTS.feature_detail_controller = createFeatureDetailController();
  }

  if (TURNERENTS.VIDEO_PAGE_DATA) {
    TURNERENTS.video_page_controller = createVideoPageController({
      static_url: TURNERENTS.static_url,
      dynamic_url: TURNERENTS.dynamic_url,
      locale: TURNERENTS.language_code,
      data: TURNERENTS.VIDEO_PAGE_DATA.data,
      videoPageTemplate: HandlebarsTemplates.videoPage,
      container: Spdy('.inline_video_container'),
      onInit: function() {
        // INITIALISE FIRST VIDEO AVAILBILE OR VIDEO FROM URL HASH
        if (getHashVariable('inlinevideoid')) {
          TURNERENTS.inlineVideoController.openVideo({
            type: getHashVariable('videotype'),
            id: getHashVariable('inlinevideoid'),
            tracking_name: getHashVariable('videoname'),
          });
        } else if (Spdy('[data-inlinevideoid]').length > 0) {
          let firstVideoOption = Spdy(Spdy('[data-inlinevideoid]').elements[0]);
          TURNERENTS.inlineVideoController.openVideo({
            type: firstVideoOption.data('videotype'),
            id: firstVideoOption.data('inlinevideoid'),
            tracking_name: firstVideoOption.data('videoname'),
          });
        }
        sizeDropdownMenus();
      },
    });
  } else {
    if (Spdy('[data-inlinevideoid]').length > 0) {
      let firstVideoOption = Spdy(Spdy('[data-inlinevideoid]').elements[0]);
      TURNERENTS.inlineVideoController.openVideo({
        type: firstVideoOption.data('videotype'),
        id: firstVideoOption.data('inlinevideoid'),
        tracking_name: firstVideoOption.data('videoname'),
        useDomID: true,
      });
    }
  }

  if (TURNERENTS.news_api && Spdy('.news_feed').length > 0) {
    Spdy('.news_feed').each(function(index, item) {
      createNewsFeedController({
        container: Spdy(item),
        static_url: TURNERENTS.static_url,
        dynamic_url: TURNERENTS.dynamic_url,
        locale: TURNERENTS.language_code,
        api_url: TURNERENTS.news_api,
        template: HandlebarsTemplates.NewsFeed,
      });
    });
  }

  if (TURNERENTS.show_lookup && Spdy('.search_autocomplete').length > 0) {
    Spdy('.search_autocomplete').each(function(index, item) {
      createSearchAutoCompleteController({
        container: Spdy(item),
        static_url: TURNERENTS.static_url,
        dynamic_url: TURNERENTS.dynamic_url,
        locale: TURNERENTS.language_code,
        data: TURNERENTS.show_lookup,
        inputField: Spdy('#mainnav_search'),
        template: HandlebarsTemplates.SearchAutoComplete,
      });
    });
  }

  Spdy('.carousel_widget.homepage_carousel').each(function(index, item) {
    let newCarousel = createCarouselWidget({
      carousel: Spdy(item),
      carousel_area: Spdy(item).find('.carousel_area'),
      children_wrapper: Spdy(item).find('.carousel_wrapper'),
      carousel_children: Spdy(item).find('.carousel_item'),
      arrows: true,
      dragging: true,
      autoscroll: true,
      controls_container: Spdy(item).find('.controls_container'),
    });
    newCarousel.init();
  });

  Spdy('.carousel_widget.related_movies--carousel').each(function(index, item) {
    let newCarousel = createCarouselWidget({
      carousel: Spdy(item),
      carousel_area: Spdy(item).find('.carousel_area'),
      children_wrapper: Spdy(item).find('.carousel_wrapper'),
      carousel_children: Spdy(item).find('.carousel_item'),
      arrows: true,
      center_mode: true,
      dragging: true,
      clone_items: true,
      autoscroll: true,
      controls_container: Spdy(item).find('.controls_container'),
    });
    newCarousel.init();
  });

  // PERFECT SCROLLBAR : https://github.com/utatti/perfect-scrollbar
  Spdy('.perfect_scrollbar').each(function(index, item) {
    new PerfectScrollbar(item, {
      wheelSpeed: 2,
      wheelPropagation: false,
      minScrollbarLength: 20,
    });
  });

  TURNERENTS.sharer = createShareController({
    device: TURNERENTS.device,
  });

  Spdy('.btn_nav_close').on('click', function() {
    Spdy(Spdy(this).parent()).removeClass('active');
    Spdy('.mobile_nav_button').removeClass('active');
    Spdy('.search_autocomplete').removeClass('active');
  });

  function resizeCallback() {
    fitText();
    removeLoading();
    sizeDropdownMenus();
  }

  function sizeDropdownMenus() {
    Spdy('.select_menu .dropdown').each(function(index, item) {
      let children = Spdy(item).find('li');
      if (children.length >= 5) {
        let childrenHeight = Spdy(children.elements[0]).outerHeight();
        Spdy(item).css('height', childrenHeight * 4 + 'px');
      }
    });
    let dropcolour = $('.inline_video_container').attr('data-dropcolour');
    $('.select_menu .selected').css('color', dropcolour);
    $('.select_menu .dropdown a').css('color', dropcolour);
  }

  function removeLoading() {
    setTimeout(function() {
      Spdy('.loading').removeClass('active');
    }, 500);
  }

  // fit text -- Breaks mobile atm
  function fitText() {
    let minFontSize = 18;
    $('.w1240 .overlay .name').each(function() {
      let f;
      while (
        $(this).height() >
        $(this)
          .parent()
          .height()
      ) {
        f = parseInt($(this).css('font-size'));
        if (f <= minFontSize) return;
        // console.log($(this).height() , $(this).parent().height(), f);
        $(this).css('font-size', --f + 'px');
      }
    });
  }

  /**
   * OLD COOKIE BAR
   * Left in for backwards compatability!
   * if TURNERENTS.oneTrustActive then this will be disabled
   */
  function checkHash() {
    let hash = window.location.hash.substring(1);
    Spdy('.links [data-trigger]').each(function(index, item) {
      if (Spdy(item).data('trigger') == hash) {
        TURNERENTS.generic_popup.onPopupOpen(item);
      }
    });
  }
  if (!TURNERENTS.oneTrustActive) {
    setTimeout(function() {
      if (!Cookies.get('turner_cookies_accept')) {
        Spdy('.cookie_bar').addClass('active');
        Spdy('.cookie_bar .agree_button').on('click', function(e) {
          Cookies.set('turner_cookies_accept', 'true');
          Spdy('.cookie_bar .pre_accept').removeClass('active');
          Spdy('.cookie_bar .post_accept').addClass('active');
        });
        Spdy('.cookie_bar .hide_button').on('click', function(e) {
          Spdy('.cookie_bar').removeClass('active');
          if (!Modernizr.preserve3d) {
            Spdy('.cookie_bar').css('display', 'none');
          }
        });
        Spdy('.cookie_bar .cookie_more').on('click', function(e) {
          // console.log('Check URL');
          checkHash();
        });
      } else {
        Spdy('.cookie_bar').css('display', 'none');
      }
    }, 500);
  }
  // OLD COOKIE BAR END

  function getHashVariable(variable) {
    let query = window.location.hash.substring(1);
    let vars = query.split('&');
    for (let i = 0; i < vars.length; i++) {
      let pair = vars[i].split('=');
      if (decodeURIComponent(pair[0]) == variable) {
        return decodeURIComponent(pair[1]);
      }
    }
    return false;
  }

  //Internal Ad tracking
  //Extra click tracking for external ads
  Spdy('[data-clickadid]').on('click', function() {
    $.ajax({
      url:
        TURNERENTS.site_url +
        'ads/click/' +
        TURNERENTS.language_code +
        '/' +
        Spdy(this).data('clickadid'),
      success: function(_data) {},
    });
  });
  Spdy('[data-adid]').each(function(index, item) {
    $.ajax({
      url:
        TURNERENTS.site_url +
        'ads/view/' +
        TURNERENTS.language_code +
        '/' +
        Spdy(item).data('adid'),
      success: function(_data) {},
    });
  });

  function hasClass(element, cls) {
    return (' ' + element.className + ' ').indexOf(' ' + cls + ' ') > -1;
  }

  const showMoreButton = document.getElementById('show-more-specials');

  if (showMoreButton) {
    showMoreButton.addEventListener('click', function(e) {
      e.preventDefault();
      let wrappers = document
        .getElementById('specials__wrapper')
        .querySelectorAll('[data-wrapper-index]');
      let BreakException = {};
      try {
        wrappers.forEach(function(element) {
          if (hasClass(element, 'wrapper--hidden')) {
            element.classList.remove('wrapper--hidden');
            element.classList.add('wrapper--show');
            throw BreakException;
          }
        });
      } catch (e) {
        if (e !== BreakException) throw e;
      }

      let hidden = document
        .getElementById('specials__wrapper')
        .getElementsByClassName('wrapper--hidden');
      if (hidden.length <= 0) {
        document.getElementsByClassName('button__show-more')[0].classList.add('hidden');
      }
    });
  }
});
